// extracted by mini-css-extract-plugin
export var award = "Awards-module--award--dcad9";
export var awards = "Awards-module--awards--2333c";
export var section = "Awards-module--section--745b9";
export var sliderContainer = "Awards-module--slider-container--3c8ce";
export var title = "Awards-module--title--76331";